import React from 'react'
import { Form, Formik } from 'formik'
import Button from './common/Button'
import { required, email } from '../utils/validators'
import Input from './common/Input'
import Select from './common/Select'

const roleOptions = [
    { value: false, name: 'Пользователь' },
    { value: true, name: 'Администратор' }
]

const statusOptions = [
    { value: true, name: 'Активен' },
    { value: false, name: 'Неактивен' }
]

export default function UserForm({ onCancel, onSubmit, loading, initialValues }) {
    const handleSubmit = (vals, actions) => {
        const data = {
            ...vals,
            isStaff: vals.isStaff || false,
            isActive: vals.isActive !== undefined ? vals.isActive : true
        }
        onSubmit(data, actions)
    }

    return (
        <Formik
            onSubmit={handleSubmit}
            initialValues={{
                firstName: '',
                lastName: '',
                email: '',
                username: '',
                password: '',
                isStaff: false,
                isActive: true,
                ...initialValues
            }}
        >
            <Form>
                <div className="columns">
                    <div className="column">
                        <Input
                            name="firstName"
                            label="Имя"
                            validate={required}
                            disabled={loading}
                        />

                        <Input
                            name="lastName"
                            label="Фамилия"
                            validate={required}
                            disabled={loading}
                        />

                        <Input
                            name="username"
                            label="Имя пользователя"
                            validate={required}
                            disabled={loading}
                        />

                        <Input
                            name="email"
                            label="Email"
                            type="email"
                            validate={email}
                            disabled={loading}
                        />

                        {!initialValues?.id && (
                            <Input
                                name="password"
                                label="Пароль"
                                type="password"
                                validate={required}
                                disabled={loading}
                            />
                        )}

                        <Select
                            name="isStaff"
                            label="Роль"
                            optionValue="value"
                            optionLabel="name"
                            options={roleOptions}
                            disabled={loading}
                        />

                        <Select
                            name="isActive"
                            label="Статус"
                            optionValue="value"
                            optionLabel="name"
                            options={statusOptions}
                            disabled={loading}
                        />
                    </div>
                </div>

                <div className="is-pulled-right">
                    <Button
                        onClick={onCancel}
                        icon="close-outline"
                        text="Закрыть"
                        className="is-danger"
                        disabled={loading}
                    />
                    &nbsp;&nbsp;
                    <Button
                        loading={loading}
                        text="Сохранить"
                        icon="add-outline"
                        type="submit"
                        className="is-success"
                        disabled={loading}
                    />
                </div>
            </Form>
        </Formik>
    )
}
